import { Component, OnInit, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';

declare const $: any;

@Component({
  selector: 'app-us-states-vector-map',
  templateUrl: './us-states-vector-map.component.html',
  styleUrls: ['./us-states-vector-map.component.css']
})
export class UsStatesVectorMapComponent implements OnInit, AfterViewInit {

  @Input() mapHeight: string = "320px";
  @Input() selectable: boolean;
  @Input() isMultipleState: boolean;
  @Output() stateSelect = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  resetMap() {
    if ($('#map').length) {
      $('#map').vectorMap('get', 'mapObject').clearSelectedRegions();
    }
  }

  resetMultipleSelectedStateMap() {
    if ($('#map3').length) {
      $('#map3').vectorMap('get', 'mapObject').clearSelectedRegions();
    }
  }

  ngAfterViewInit() {
    $('#map').vectorMap({
      onRegionClick: (event, data) => {
        this.stateSelect.emit(data);
      },
      map: 'us_aea_en',
      backgroundColor: 'transparent',
      regionsSelectable: true,
      regionsSelectableOne: true,
      regionStyle: {
        initial: {
          fill: 'cornflowerblue'
        },
        selected: {
          fill: 'orange'
        }
      }
    });

    $('#map2').vectorMap({
      onRegionClick: (event, data) => {
        this.stateSelect.emit(data);
      },
      map: 'us_aea_en',
      backgroundColor: 'transparent',
      regionsSelectable: false,
      regionsSelectableOne: false,
      regionStyle: {
        initial: {
          fill: 'cornflowerblue'
        },
        selected: {
          fill: 'orange'
        }
      }
    });

    $('#map3').vectorMap({
      onRegionClick: (event, data) => {
        this.stateSelect.emit(data);
      },
      map: 'us_aea_en',
      backgroundColor: 'transparent',
      regionsSelectable: true,
      regionsSelectableOne: false,
      regionStyle: {
        initial: {
          fill: 'cornflowerblue'
        },
        selected: {
          fill: 'orange'
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/us-states-vector-map/us-states-vector-map.component.ts